import { render, staticRenderFns } from "./EventIcon.vue?vue&type=template&id=7bc45194&"
import script from "./EventIcon.vue?vue&type=script&lang=js&"
export * from "./EventIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports